export default __webpack_public_path__ + "static/media/upload_icon.d8fb3931.svg";